import type { ReactNode } from 'react'
import { FormControl, FormLabel, Input, Text } from '@chakra-ui/react'
import type { UseFormRegisterReturn } from 'react-hook-form'

interface LocationFormFieldProps {
  label: string
  registration: UseFormRegisterReturn
  error?: string
  isRequired?: boolean
  placeholder?: string
  type?: 'text' | 'email' | 'tel'
  children?: ReactNode
}

export const LocationFormField = ({
  label,
  registration,
  error,
  isRequired = false,
  placeholder,
  type = 'text',
  children,
}: LocationFormFieldProps) => {
  const isInvalid = Boolean(error)

  return (
    <FormControl isInvalid={isInvalid} isRequired={isRequired}>
      <FormLabel
        htmlFor={registration.name}
        mb={1.5}
        fontSize="sm"
        fontWeight="semibold"
        color="gray.900"
      >
        {label}
      </FormLabel>
      {children ?? (
        <Input
          id={registration.name}
          type={type}
          placeholder={placeholder}
          height="42px"
          borderRadius="md"
          _placeholder={{ color: 'gray.400' }}
          {...registration}
        />
      )}
      {error && (
        <Text fontSize="sm" fontWeight="medium" color="red.600" mt={1}>
          {error}
        </Text>
      )}
    </FormControl>
  )
}
